import { useCallback, type FC } from "react";
import { WorkflowEditTriggerItem } from "@/components/automations/AutomationEditTriggerItem";
import {
    type WorkflowEditFormTriggerData,
} from "@/components/automations/automation-edit-form-data";
import { Text } from "@/components/podkit/typography/Text";
import type { PlainWorkflow } from "@/queries/automation-queries";

type WorkflowEditTriggersProps = {
    workflow: PlainWorkflow;
    triggers: WorkflowEditFormTriggerData[];
    onTriggersChange: (triggers: WorkflowEditFormTriggerData[]) => void;
};

export const WorkflowEditTriggers: FC<WorkflowEditTriggersProps> = ({ workflow, triggers, onTriggersChange }) => {
    const handleUpdateTrigger = useCallback(
        (triggerId: string, updatedTrigger: WorkflowEditFormTriggerData) => {
            onTriggersChange(triggers.map((trigger) => (trigger.id === triggerId ? updatedTrigger : trigger)));
        },
        [triggers, onTriggersChange],
    );

    return (
        <div className="flex flex-col gap-3">
            {triggers.length === 0 ? (
                <Text className="text-sm text-content-destructive">At least one trigger is required.</Text>
            ) : (
                <>
                    {triggers.map((trigger) => (
                        <WorkflowEditTriggerItem
                            key={trigger.id}
                            workflow={workflow}
                            trigger={trigger}
                            onUpdate={(updatedTrigger) => handleUpdateTrigger(trigger.id, updatedTrigger)}
                        />
                    ))}
                </>
            )}
        </div>
    );
};
